export default "__VITE_ASSET__CGlnovGE__"